<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style lang="less">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  .demo-drawer-1 {
    .ivu-drawer-body {
      overflow: auto;
      padding-bottom: 53px;
      position: static;
    }
    .demo-drawer-footer{
      width: 100%;
      position: absolute;
      bottom: 0;
      left: 0;
      border-top: 1px solid #e8e8e8;
      padding: 10px 16px;
      text-align: right;
      background: #fff;
      z-index: 99;
    }
  }
  .narrow-table .ivu-table-cell {
    padding-left: 1px;
    padding-right: 1px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue